import { Controller } from '@hotwired/stimulus';
import { Chart, BarController, BarElement, PointElement, LinearScale, Title, Legend, CategoryScale } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default class extends Controller {
  static targets = ['context'];
  static values = {
    comparism: Array,
  };

  connect() {
    Chart.register(BarController, ChartDataLabels, BarElement, PointElement, LinearScale, Legend, Title, CategoryScale);
    this.chart = new Chart(this.ctx(), {
      type: 'bar',
      data: {
        labels: ['Resources', 'Activity Lists', 'Goals'],
        datasets: [
          {
            label: 'Basic',
            data: this.comparismValue[0],
            backgroundColor: ['rgba(94, 156, 242, 0.9)'],
            borderColor: ['rgba(94, 156, 242, 1)'],
            borderWidth: 1,
          },
          {
            label: 'Essential',
            data: this.comparismValue[1],
            backgroundColor: ['rgba(245, 120, 66, 0.9)'],
            borderColor: ['rgba(245, 120, 66)'],
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'top',
            offset: 4,
            color: '#1C3158',
            font: {
              weight: 'bold',
            },
          },
          legend: {
            display: true,
            position: 'right',
            align: 'start',
          },
          title: {
            display: true,
            text: 'Ambiki material comparison',
          },
        },
        scales: {
          y: {
            display: false,
          },
          x: {
            grid: {
              display: false,
            },
          },
        },
      },
    });
  }

  ctx() {
    return this.contextTarget.getContext('2d');
  }
}
